import { useFlag } from '@afterpaytouch/feature'
import { parseCookies } from 'nookies'
import { ApplePayEntryData, ApplePaylaterInitialState, CheckoutAppSelector, useAppSelector, useCheckoutState } from '..'
import { APPLE_ORDER_SOURCES, Features } from '../../model'
import { FLOW_COOKIE_NAME, FlowCookieValue } from '../../utils/server/flowCookie'

export const applePaylaterSelector: CheckoutAppSelector<ApplePaylaterInitialState> = (state) => state.applePaylater

export const useApplePayEntryData = (): ApplePayEntryData | undefined => {
  const applePayEntryData = useAppSelector(applePaylaterSelector)
  return applePayEntryData.entryData
}

export const useIsApplePaylaterEnabled = (): boolean => {
  return useFlag(Features.APPLE_PAYLATER_INTEGRATION)
}

export const useIsApplePaylater = (): boolean => {
  const { checkout } = useCheckoutState()

  const cookies = parseCookies()
  const flowCookie = cookies[FLOW_COOKIE_NAME] as FlowCookieValue | undefined
  const fromCookie = flowCookie === FlowCookieValue.ApplePaylater

  const isApplePaylaterMerchant = checkout?.merchant?.source ? APPLE_ORDER_SOURCES.includes(checkout.merchant.source) : false

  return fromCookie && isApplePaylaterMerchant
}

export const useUserHasApplePaylaterCard = (): boolean | undefined => {
  const applePayState = useAppSelector(applePaylaterSelector)
  return applePayState.userHasApplePaylaterCard
}

export const useUserHasInstoreCard = (): boolean | undefined => {
  const applePayState = useAppSelector(applePaylaterSelector)
  return applePayState.userHasInstoreCard
}
